<ng-container *ngIf="activities$ | async as activities">
	<div
		*ngIf="activities.length > 0"
		class="activity-mover">
		<label class="goreact-label dropdown-label">
			<span>{{labelText}}</span>&nbsp;
			<span
				[attr.aria-label]="{'aria-label': 'session-selector_moving-submission-help-aria-label'}"
				class="ficon-help"
				[matTooltip]="'session-editor_activities_disabled' | translate"
				matTooltipPosition="above">
			</span>
		</label>
		<div class="activity-selector">
			<mat-form-field goSelect>
				<mat-select
					disableOptionCentering
					panelClass="offsetPanel"
					[ngModel]="activity"
					(ngModelChange)="handleChange($event)"
					[disabled]="disabled">
					<mat-option
						*ngFor="let activity of activities"
						[value]="activity"
						[disabled]="disabledOption(activity)">
						{{ activity.name }}
					</mat-option>
				</mat-select>
				<mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
			</mat-form-field>
		</div>
	</div>
</ng-container>
